import { Link } from 'react-router-dom';
import { Badge } from '@shared/ui/Badge';
import { Card, CardTitle } from '@shared/ui/Card';
import { useGetKadrySmsStatusQuery } from '@shared/api';
import { kadryMoney } from '@entities/kadry';
import { KadryCardHead, KadryErrorBanner, KadryMuted } from '../ui';
import { CardBody, Line } from './connectionsShared';

/** SMS (Р19): ключ задаётся на сервере, здесь — состояние и баланс. */
export function SmsStatusCard() {
  const { data: st, error, refetch } = useGetKadrySmsStatusQuery();
  if (error) return <KadryErrorBanner error={error} onRefresh={refetch} />;
  if (!st) return null;
  const ready = st.configured && st.gate_enabled && st.profile_approved;

  return (
    <Card>
      <KadryCardHead>
        <CardTitle>SMS (SMS.ru)</CardTitle>
        {ready ? (
          <Badge $tone="success">отправляет{st.sender ? ` от ${st.sender}` : ''}</Badge>
        ) : st.configured ? (
          <Badge $tone="warning">не включено</Badge>
        ) : (
          <Badge $tone="neutral">не подключено</Badge>
        )}
      </KadryCardHead>
      <CardBody>
        <KadryMuted>
          Кому ушло предложение и чей телефон известен, получает SMS со ссылкой на кнопки «Подходит / Не
          подходит». Отправка — с 9 до 20 по времени объекта, у кандидата из поиска hh — после приглашения
          (тогда открывается телефон).
        </KadryMuted>
        {st.configured ? (
          <>
            <Line>
              Баланс SMS.ru:{' '}
              {st.balance_rub != null ? kadryMoney(st.balance_rub) : st.balance_error ?? 'неизвестен'}
            </Line>
            <Line>
              Отправлено за сутки: {st.sent_24h} из {st.daily_limit}
            </Line>
          </>
        ) : (
          <KadryMuted>
            Ключ SMS.ru (api_id) задаётся на сервере ОСНОВЫ: переменная OSNOVA_KADRY_SMSRU_API_ID.
          </KadryMuted>
        )}
        {!st.gate_enabled && (
          <KadryMuted>
            Канал выключен в разделе <Link to="/agents/kadry/settings/gates">«Функции»</Link>.
          </KadryMuted>
        )}
        {!st.profile_approved && <KadryMuted>Профиль обработки «SMS.ru» не утверждён — ниже, в готовности.</KadryMuted>}
        <KadryMuted>
          Имя отправителя подключается у каждого оператора отдельно (кабинет SMS.ru → «Отправители»). Если
          оператор не подключён, у кандидата в реестре будет «SMS: ошибка» с этой причиной.
        </KadryMuted>
      </CardBody>
    </Card>
  );
}

export { SmsStatusCard as SmsCard };
